package geometry

import com.github.chosamuel.kishibe.math.Vector2
import dm
import kotlinx.browser.window
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sin

class PolarGrid(
    val center: Vector2,
    val radius: Double = 300.0,
    val rungs: Int = 3,
    val spokes: Int = 12,
) {
    constructor(x: Double, y: Double):this(Vector2(x,y))
    constructor(
        x: Double,
        y: Double,
        radius: Double,
        rungs: Int,
        spokes: Int
    ):this(Vector2(x,y),radius,rungs,spokes)
    var points = mutableListOf<Vector2>()

    fun createPoints(): List<Vector2>{
        val W = window.innerWidth.toDouble()
        val H = window.innerHeight.toDouble()
        val displaceSize = 50.0
        val displace = dm.div(Vector2(W,H))
            .times(2.0)
            .minus(1.0)
            .times(displaceSize*rungs*1.2)

        val ptx = mutableListOf<Vector2>()
        ptx.add(center.plus(displace))
        val stepTheta = (PI *2.0)/(spokes-1.0)
        val stepRadius = radius / rungs.toDouble()

        repeat(spokes){ th ->
            repeat(rungs){ r ->
                val rungPos = rungs - r
                val displace = dm.div(Vector2(W,H))
                    .times(2.0)
                    .minus(1.0)
                    .times(rungPos.toDouble() * displaceSize)
                val rad = (r+1) * stepRadius
                val theta = stepTheta * th
                val pt = Vector2(cos(theta), sin(theta))
                    .times(rad + (r*rad))
                    .plus(center)
                    .plus(displace)
                ptx.add(pt)
            }
        }
        points = ptx
        return ptx
    }

    fun getIndices(): List<Int> {
        val indices = mutableListOf<Int>()
        val numIndices = (((rungs-1) * 2) + 1) * spokes * 3
        for(i in 0 until rungs){
            //if inner 0
            for(j in 0 until spokes){
                if(i == 0){
                    //INNER TRIANGLE
                    val index = (j*rungs) + 1
                    val nextIndex = if(j<spokes-1)
                        ((j+1)*rungs)+1
                    else 1
                    indices.add(0)
                    indices.add(index)
                    indices.add(nextIndex)
                } else {
                    val tl = (j*rungs) +  i//top left
                    val tr = (j*rungs) + i+1 //top right
                    val bl = if(j<spokes-1) ((j+1)*rungs)+i else i
                    val br = if(j<spokes-1) ((j+1)*rungs)+i+1 else i+1
                    indices.add(tl)
                    indices.add(tr)
                    indices.add(bl)

                    indices.add(tr)
                    indices.add(br)
                    indices.add(bl)
                }
            }
        }
        return indices
    }

}